/* eslint-disable no-underscore-dangle */
const canUseDOM = !!(
    (typeof window !== 'undefined' &&
        window.document && window.document.createElement)
);
let _rox;
const _options = { platform: 'SSR' }; // override the default platfrom

if (canUseDOM) {
    // eslint-disable-next-line global-require
    _rox = require('rox-browser');
} else {
    // eslint-disable-next-line no-eval
    _rox = eval('require(\'rox-node\')');
    if (_rox) {
        // nice to have
        _rox.setContext({ server: true });
    }
}

export const Rox = _rox;

export const setup = async (appKey, options) => {
    if (canUseDOM) {
        // on client get the data from node to the client to have a sync behavior of the SDK
        const ssrData = window.ROLLOUT_DATA;
        _options.embedded = JSON.stringify(ssrData);
        _options.disableNetworkFetch = true;
    } else {
        // on the server - keep updating the data of experiments
        _options.configurationFetchedHandler = fetcherResults => {
            if (fetcherResults.hasChanges) {
                _rox.latestConfiguration = fetcherResults.clientData;
            }
        };
    }
    // async await -- on server waits for first network data to arrive
    return _rox.setup(appKey, { ..._options, ...options });
};

// export const setContextProps = async function(user) {
//     Rox.setCustomStringProperty("email", user.email.toLowerCase());
//     Rox.setCustomNumberProperty("memberId", user.id);
//     Rox.setCustomBooleanProperty("isClubOrganizer", user.isClubOrganizer);
//     Rox.setCustomBooleanProperty("isEnterpriseClubOrganizer", user.isEnterpriseClubOrganizer);
// }

export const setContextProps = () => {
    Rox.setCustomStringProperty('email', (context) => {
        // debugger;
        // return context.user.email;
        return context.user && context.user.email;
    });
    Rox.setCustomNumberProperty('memberId', (context) => {
        // return context.user.id;
        return context.user && context.user.id;
    });
    Rox.setCustomBooleanProperty('isClubOrganizer', (context) => {
        // return context.user.isClubOrganizer;
        return context.user && context.user.isClubOrganizer;
    });
    Rox.setCustomBooleanProperty('isEnterpriseClubOrganizer', (context) => {
        // return context.user.isEnterpriseClubOrganizer;
        return context.user && context.user.isEnterpriseClubOrganizer;
    });
};

export const getFlagsContext = (user) => {
    // if (canUseDOM) {
    //     console.log('browser getFlagsContext: ', user);
    // } else {
    //     console.log('ssr getFlagsContext: ', user);
    // }

    const isValidUser = (user && Object.keys(user).length > 0 && (user.email && user.email.length > 0) && user.id > 0);

    if (isValidUser) {
        return {
            user: {
                email: user.email.toLowerCase(),
                memberId: user.id,
                isClubOrganizer: user.isClubOrganizer,
                isEnterpriseClubOrganizer: user.isEnterpriseClubOrganizer,
            },
        };
    }
    return {
        user: {},
    };
};
